import React from "react";
import NavigationIcon from "@mui/icons-material/Navigation";

//Types
import { SvgIconProps } from "@mui/material";

function POIIconVrh(props: SvgIconProps) {
  return <NavigationIcon {...props}/>;
}

export default POIIconVrh;
